<style lang="scss" scoped>
  .news-details{
    width:1000px;
    margin:0 auto;
    .title{
      font-size: 36px;
      text-align: center;
      font-weight: bold;
      margin-top: 30px;
    }
    .resource{
      text-align: center;
      color:#999;
      margin-top: 10px;
      span{
        margin:0 20px;
      }
    }
    .context{
      margin-top: 30px;
      p{
        text-indent: 2rem;
        margin-bottom: 20px;
        line-height: 2;
      }
      img{
        width:80%;
        margin:0 auto 20px;
        display: block;
      }
    }
  }
  @media screen and (max-width: 640px){
    .news-details{
      width: 90% !important;
      margin-bottom: 20px;
    }
    .news-details .title{
      font-size: 25px!important;
    }
    .context>>> img{
      width: 100%;
    }
  }
</style>
<template>
  <section class="news-details">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>营销内容</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="title">{{details.name}}</div>
    <div class="resource"><span>时间：{{details.createTime | rTime}}</span></div>
    <div class="context" v-html="details.content">
<!--      <p>2018年伊始，擎科生物正式与东湖高新集团签约，IVD原料及分子生物学相关试剂研发中心项目入驻东湖高新集团园区东湖高新智慧城该-->
<!--        项目总投资1亿元，分三期投资建设，坐拥3000平符合GMP标准的IVD无菌净化研发中心。</p>-->
<!--      <img src="@/assets/images/banner_1.png" class="img-fluid">-->
    </div>
  </section>
</template>

<script>
import { marketContents } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  data () {
    return {
      details: {}
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    getDetails () {
      const id = this.$route.query.id
      marketContents(id).then(res => {
        this.details = res.data
        console.log("ss",res.data)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/news/market.vue